import {environment} from 'src/environments/environment';
import {appStateConfig} from './app.config';

export const COOKIE_OPTIONS: {
  expires?: number | Date;
  path?: string;
  domain?: string;
  sameSite?: 'Strict' | 'Lax' | 'None';
  httpOnly?: boolean;
  secure?: boolean;
  other?: string;
} = {
  path: `${appStateConfig.initState.name}/`,
  domain: undefined,       // Percorso del cookie
  secure: environment.secure,    // Imposta su true se stai usando HTTPS
  sameSite: 'Strict',  // Impedisce il CSRF
  expires: 360, // Data di scadenza del cookie
}
